import axios from "axios";

// Same-origin API base on the live domain (avoids apex→www redirect CORS issues);
// preview/development uses the configured backend URL.
const isLiveDomain = /(^|\.)noordb\.co\.uk$/.test(window.location.hostname);
const API_BASE = isLiveDomain
  ? `${window.location.origin}/api`
  : `${process.env.REACT_APP_BACKEND_URL}/api`;

export const API = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const adminApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("noor-admin-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const API_BASE_URL = API_BASE;

export const telLink = (settings) =>
  `tel:+44${(settings?.phone || "07782760279").replace(/^0/, "")}`;

export const waLink = (settings) =>
  `https://wa.me/44${(settings?.whatsapp || "07782760279").replace(/^0/, "")}?text=${encodeURIComponent(
    settings?.whatsapp_message ||
      "Hello NOOR Design & Build. I'm considering a building project and would like to arrange an initial consultation."
  )}`;

export const track = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (window.fbq) window.fbq("trackCustom", event, params);
};

let analyticsLoaded = false;
export function injectAnalytics(settings) {
  if (analyticsLoaded || !settings) return;
  if (localStorage.getItem("noor-cookie-consent") !== "accepted") return;
  analyticsLoaded = true;
  const gaId = settings.ga4_id;
  const adsId = settings.google_ads_id;
  const gtagId = gaId || adsId;
  if (gtagId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    if (gaId) window.gtag("config", gaId);
    if (adsId) window.gtag("config", adsId);
  }
  if (settings.meta_pixel_id) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", settings.meta_pixel_id);
    window.fbq("track", "PageView");
  }
}
